import { render, staticRenderFns } from "./SortPage.vue?vue&type=template&id=25a46f67&scoped=true&"
import script from "./SortPage.vue?vue&type=script&lang=js&"
export * from "./SortPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a46f67",
  null
  
)

export default component.exports